import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
export default {
    execute: async (data) => {
        const { index, id, form, submitBtn } = data;
        const payload = {
            id,
            title: form.servicetitle.value.trim(),
            desc: form.description.value.trim(),
            price: Number(form.price.value.trim()),
            orderIndex: index
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/services/update', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Service updated successfully.`
            });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
